import type { GridColDef } from '@mui/x-data-grid';
import DateTimeFormat from '../../../../../../components/dateTimeFormat';

type CommonOpts = {
    includeSarlaftId?: boolean;
    caseLabel?: string;
};

export function generateDefaultColumns(opts: CommonOpts = {}): GridColDef[] {
    const { includeSarlaftId = true, caseLabel = 'ID Caso' } = opts;

    const cols: GridColDef[] = [
        {
            field: 'createdAt',
            headerName: 'Fecha de creación',
            flex: 1,
            minWidth: 160,
            renderCell: (p) => <DateTimeFormat dateAt={p.row.createdAt} />,
        },
        { field: 'caseId', headerName: caseLabel, flex: 1, minWidth: 140 },
        ...(includeSarlaftId
            ? [
                {
                    field: 'sarlaftId',
                    headerName: 'ID SARLAFT',
                    flex: 1,
                    minWidth: 160,
                },
            ]
            : []),
        {
            field: 'typification',
            headerName: 'Tipificación',
            flex: 1.2,
            minWidth: 200,
        },
        {
            field: 'observation',
            headerName: 'Observación',
            flex: 1.4,
            minWidth: 220,
        },
        { field: 'caseStatus', headerName: 'Estado', flex: 1, minWidth: 120 },
        { field: 'plate', headerName: 'Placa', flex: 1, minWidth: 120 },
        { field: 'policy', headerName: 'Póliza', flex: 1, minWidth: 140 },
        { field: 'callId', headerName: 'Call ID', flex: 1, minWidth: 140 },
        { field: 'userName', headerName: 'Usuario', flex: 1, minWidth: 140 },
    ];

    return cols;
}

export const generateAllColumns = () =>
    generateDefaultColumns({
        includeSarlaftId: false,
        caseLabel: 'ID Caso / PQR',
    });

export const generatePqrColumns = () =>
    generateDefaultColumns({ includeSarlaftId: false, caseLabel: 'ID PQR' });

export const generateOthersColumns = () =>
    generateDefaultColumns({ includeSarlaftId: true, caseLabel: 'ID Caso' });
